import React from 'react'
import EmailTable from './components/tables/EmailTable'

export default class Emails extends React.Component {
  constructor(props) {
    super(props)

    this.state = {}
  }
  render() {
    return (
      <>
        <div className="post d-flex flex-column-fluid" id="kt_post">
          <div id="kt_content_container" className="container-xxl">
            <EmailTable title={'Emails'} />
          </div>
        </div>
      </>
    )
  }
}
